import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/service-request-set-type";

export const getAllServiceRequestSetType = () => axios.get(API_PATH + "/get-all");

export const pagingServiceRequestSetType = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getServiceRequestSetTypeById = (ServiceRequestSetTypeId) => axios.get(API_PATH + "/get-by-id/" + ServiceRequestSetTypeId);

export const saveOrUpdateServiceRequestSetType = ServiceRequestSetType => axios.post(API_PATH + "/save", ServiceRequestSetType);

export const deleteServiceRequestSetType = ServiceRequestSetTypeId => axios.delete(API_PATH + '/mark-delete/' + ServiceRequestSetTypeId);
